module.exports = __webpack_public_path__ + "static/img/2968338.1666c48.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/2968338.svg
// module id = mK6E
// module chunks = 4